export default __webpack_public_path__ + "static/5-mobile-02c28a76d07fba15876bb2126d55bb9d.webp";